import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { UploadLoanDocumentToS3Props } from '../../types'
import uploadLoanDocumentToS3 from './function'

const useUploadLoanDocumentToS3 = () => {
  const toast = useToast()
  const [progress, setProgress] = useState(0)

  const mutation = useMutation({
    mutationFn: (props: UploadLoanDocumentToS3Props) => {
      return uploadLoanDocumentToS3({
        file: props?.file,
        customerId: props?.customerId,
        onecode: props?.onecode,
        ocFieldCode: props?.ocFieldCode,
        partnerId: props?.partnerId,
        fileName: props?.fileName,
        uploadProgress: (value) => setProgress(value),
      })
    },
    onSuccess: () => {
      toast?.show({
        intent: 'success',
        heading: 'Document Uploaded succesfully',
        hideAfter: 3000,
      })
    },
    onError: () => {
      setProgress(0)
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })

  return {
    ...mutation,
    progress,
  }
}

export default useUploadLoanDocumentToS3
